import Notification from "./Notification";

const data = {
    appList: [
        {
            name: "startups-edu-web",
            entry: process.env.NODE_ENV === "development" ? "http://47.113.216.124:30020" : "https://startups168.nowui.com/startups-edu-web/",
            container: "#container",
            activeRule: "#/edu/",
            props: {
                Notification: Notification,
            },
        },
        {
            name: "startups-web",
            entry: process.env.NODE_ENV === "development" ? "http://47.113.216.124:30010" : "https://startups168.nowui.com/startups-web/",
            container: "#container",
            activeRule: (location) => {
                if (location.hash.startsWith("#/edu/")) {
                    return false;
                } else {
                    return true;
                }
            },
            props: {
                Notification: Notification,
            },
        },
    ],
};

export default data;
